import type { ISerialize } from '@/objects/ISerialize';

export class ContestantInfoResponse implements ISerialize {
    public ContestantID: number;

    public Ingress: string | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { ContestantID?: number; Ingress?: string | null }) {
        this.ContestantID = values.ContestantID ?? 0;

        this.Ingress = values.Ingress ?? '';
    }

    public serialize(): string {
        return '{' + `"ContestantID": ${JSON.stringify(this.ContestantID)}` + ',' + `"Ingress": ${JSON.stringify(this.Ingress)}` + '}';
    }

    /**
     * Creates an instance of ContestantInfoResponse from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { ContestantID?: number; Ingress?: string | null }): ContestantInfoResponse {
        return new ContestantInfoResponse(values);
    }

    public static _FromServerJson(json: any): ContestantInfoResponse {
        return new ContestantInfoResponse({ ContestantID: json.ContestantID, Ingress: json.Ingress ?? '' });
    }

    /**
     * Creates an instance of ContestantInfoResponse from another instance of ContestantInfoResponse.
     * @param other The ContestantInfoResponse you want to clone
     * @returns A cloned ContestantInfoResponse
     */
    public static FromOther(other: ContestantInfoResponse): ContestantInfoResponse {
        return ContestantInfoResponse._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ContestantInfoResponse.FromOther(this);
    }

    static NAME_OF_CLASS = 'ContestantInfoResponse';
}
